var map = {
	"./BOT.png": 99390,
	"./Career-Development.png": 30171,
	"./Cutting-Edge-Technology.png": 86144,
	"./Inclusive-Environment.png": 13583,
	"./Innovative-Culture.png": 8657,
	"./PPT.png": 34473,
	"./app.png": 79516,
	"./apple.png": 31325,
	"./arrow-right.png": 55707,
	"./call-icon.png": 45643,
	"./call.png": 38093,
	"./chat-icon.png": 95705,
	"./chatbot-icon.png": 68128,
	"./coming-soon-datasheet.png": 90424,
	"./coming-soon-diagram.png": 61958,
	"./coming-soon-manual.png": 59907,
	"./connect.png": 96767,
	"./dedicated-support.png": 18036,
	"./download-connectiondiagram.png": 29721,
	"./download-datasheet.png": 42479,
	"./download-usermanual.png": 51995,
	"./facebook.png": 43853,
	"./google.png": 63284,
	"./innovative-solution.png": 99434,
	"./instagram.png": 63505,
	"./left-arrow.svg": 92104,
	"./linkedin.png": 36871,
	"./location.png": 42012,
	"./mail.png": 35692,
	"./market-research.png": 38779,
	"./payment.png": 32951,
	"./pdf.png": 26831,
	"./phone-call.png": 84060,
	"./phone.png": 27321,
	"./pinterest.png": 68819,
	"./playstore.png": 9192,
	"./quote.png": 661,
	"./right-arrow.svg": 14263,
	"./sales.png": 86685,
	"./search-icon.png": 85391,
	"./smartphone.png": 16848,
	"./support.png": 9660,
	"./supportImage.png": 90813,
	"./telephone.png": 29105,
	"./thank.png": 95485,
	"./trusted-brand.png": 26036,
	"./tw-icon.png": 39894,
	"./twitter.png": 51552,
	"./whatsapp-icon.png": 79197,
	"./whatsapp.png": 76287,
	"./youtube.png": 74026
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;